import React from "react"
import type { CustomFieldText } from "@love-irish/types"
import { Badge } from "@love-irish/ui-components"

const TextField = ({ field }: { field: CustomFieldText }) => {
  // Special handling for plural_form - link to codex record
  if (field.key === "plural_form" && field.value) {
    return (
      <Badge variant="outline">
        <strong className="mr-1">{field.label}:</strong>{" "}
        <a
          href={`/codex/${field.value}`}
          className="underline hover:text-primary"
        >
          {field.value}
        </a>
      </Badge>
    )
  }

  return (
    <Badge variant="outline">
      <strong className="mr-1">{field.label}:</strong> {field.value}
    </Badge>
  )
}

export default TextField
